<script setup lang="ts">
import { ref } from "vue";
import InputDateTime from "@/components/InputDateTime.vue";
import { ConfirmBanner } from "@/components/ui/confirm";
import dayjs from "dayjs";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  activityOptions: {
    type: Array,
    required: true
  },
  stages: {
    type: Array,
    default: () => []
  },
  timezone: {
    type: String,
    required: true
  },
})

const csrf_token = window.Laravel.csrfToken;

const variant = ref(props.modelValue);
</script>

<template>
  <form :action="variant.update_url" method="POST">
    <input type="hidden" name="_method" value="PUT">
    <input type="hidden" name="_token" :value="csrf_token">
    <fieldset class="tw:bg-zinc-50 tw:rounded-lg tw:p-4">
      <strong class="tw:block tw:mb-3">{{ $t('Options') }}</strong>
      <template v-for="activityOption in props.activityOptions?.filter((option) => variant.option_values.map(value => value.activity_option_id).includes(option.id))">
        <div class="form-group">
          <label>
            {{ activityOption.name }}
          </label>
          <select class="form-control"
                  name="activity_option_values[]"
                  :value="variant.option_values.find(value => value.activity_option_id === activityOption.id)?.id"
                  :required="activityOption.required">
            <option v-for="optionValue in activityOption.values" :key="optionValue.id" :value="optionValue.id">
              {{ optionValue.value ?? optionValue.code }}
            </option>
          </select>
        </div>
      </template>
    </fieldset>
    <hr>
    <div class="form-group">
      <label>
        {{ $t('Quota')}} ({{ $t('optional')}})
      </label>
      <input type="number"
             name="quota"
             :value="variant.quota.total"
             id="activity_variant_name"
             inputmode="numeric"
             class="form-control">
    </div>
    <div class="form-group">
      <label>
        {{ $t('Sales start at')}} ({{ $t('optional')}})
      </label>
      <InputDateTime
        :timezone="timezone"
        hidden-name-input="sale_start_at"
        :date="variant.sale_start_at ? dayjs.utc(variant.sale_start_at) : null"
        datetime-class="input-group"
        ></InputDateTime>
    </div>

    <div class="form-group">
      <label>
        {{ $t('Sales end at')}} ({{ $t('optional')}})
      </label>
      <InputDateTime
        :timezone="timezone"
        hidden-name-input="sale_end_at"
        :date="variant.sale_end_at ? dayjs.utc(variant.sale_end_at) : null"
        datetime-class="input-group"
      ></InputDateTime>
    </div>

    <hr>
    <fieldset class="form-group">
      <legend>{{ $t('Associated stages/dates') }} ({{ $t('optional')}})</legend>
      <small class="text-muted">{{ $t('Select one or more stages that participants will automatically be associated to when ordering this variant.')}}</small>
      <template v-for="stage in props.stages" :key="stage.id">
        <div class="form-check">
          <input class="form-check-input"
                 type="checkbox"
                 :value="stage.id"
                 :id="'stage_' + stage.id"
                 name="stages[]"
                 :checked="variant.stages.map((variantStage) => variantStage.id).includes(stage.id)">
          <label class="form-check-label" :for="'stage_' + stage.id">
            {{ stage.name }}
          </label>
        </div>
      </template>
    </fieldset>


    <button class="btn btn-primary">
      {{ $t('Save') }}
    </button>
  </form>

  <ConfirmBanner
    severity="danger"
    method="DELETE"
    title="Delete this variant"
    description="Once you delete it, there is no going back. Please be certain."
    trigger-label="Delete this variant"
    message="Once you delete it, there is no going back. Please be certain."
    confirm-label="Delete"
    :action="variant.update_url"
  />

</template>
